import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  public isInMaintenanceMode = new BehaviorSubject<boolean>(false);
  isInMaintenanceMode$ = this.isInMaintenanceMode.asObservable();

  public maintenanceType = new BehaviorSubject<'offline' | 'maintenance'>('offline');
  maintenanceType$ = this.maintenanceType.asObservable();

  showMaintenancePage(type: 'offline' | 'maintenance' = 'offline') {
    this.maintenanceType.next(type);
    this.isInMaintenanceMode.next(true);
  }

  hideMaintenancePage() {
    this.isInMaintenanceMode.next(false);
  }
}
